/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "iframeResizerContentWindow" }] */

import { hosts } from './hosts'
import iframeResizerContentWindow from 'iframe-resizer'
import { continueWithSave } from './JiraAdapterHelpers'

const initialExampleMap = { 'rules': [[]], 'questions': [] }

let iFrameReadyResolve = null
const iFrameReady = new Promise((resolve) => {
  iFrameReadyResolve = resolve
})

const registeredPromises = {}

const receiveMessage = (message) => {
  console.log('inner: received message')
  console.log(message)

  if (!('method' in message)) {
    console.error('inner: do not understand message')
    console.error(message)
    return
  }

  const method = message.method
  if (!(method in registeredPromises)) {
    console.error('inner: got message for unregistered method')
    console.error(message)
    return
  }

  const resolveReject = registeredPromises[method]
  delete registeredPromises[method]

  if ('error' in message) {
    console.log('inner: resolve with error')
    resolveReject.reject(message.error)
    return
  }

  if ('value' in message) {
    console.log('inner: resolve with value')
    resolveReject.resolve(message.value)
  } else {
    console.log('inner: resolve with no value')
    resolveReject.resolve()
  }
}

// The iFrameResizer could be loaded before we register
// for the onReady event, but it seems to work...
window.iFrameResizer = {
  onReady: iFrameReadyResolve,
  onMessage: receiveMessage
}

const sendMessage = message => {
  if (!('parentIFrame' in window)) {
    console.error('no parentIFrame in window')
    return
  }

  console.log('inner: sending message')
  console.log(message)
  window.parentIFrame.sendMessage(message)
}

let requestIndex = 0
const invokeOuterMethod = async (methodName, parameters) => {
  console.log('inner: waiting for frame')

  await iFrameReady

  console.log('inner: frame ready')

  const responseName = methodName + '-response-' + requestIndex++

  const responsePromise = new Promise((resolve, reject) => {
    if (responseName in registeredPromises) {
      const errorMessage = 'Request already in progress: ' + methodName
      console.error('inner: ' + errorMessage)
      throw errorMessage
    }

    registeredPromises[responseName] = {
      resolve: resolve,
      reject: reject
    }
  })

  sendMessage({
    method: methodName,
    response: responseName,
    parameters: parameters || []
  })

  return responsePromise
}

export default class JiraServerAdapter {
  async fetchExampleMap () {
    try {
      return await invokeOuterMethod('load-em')
    } catch (error) {
      if (error.status === 404) {
        return initialExampleMap
      } else {
        console.log(error)
        throw error
      }
    }
  }

  async load () {
    const loadStart = Date.now()
    let exampleMap = await this.fetchExampleMap()
    window.amplitude.getInstance().logEvent('em_load_examplemap_server', { loadTime: Date.now() - loadStart })

    if (exampleMap === null) {
      exampleMap = initialExampleMap
    }

    this.lastKnownExampleMap = JSON.stringify(exampleMap)
    return exampleMap
  }

  async save (state, options) {
    let allowOverwrite = true
    if (typeof options !== 'undefined' && typeof options.allowOverwrite !== 'undefined') {
      allowOverwrite = options.allowOverwrite
    }

    // if the EM has been saved elsewhere give the option to reload or overwrite
    if (!await continueWithSave(allowOverwrite, this.lastKnownExampleMap, () => this.fetchExampleMap())) {
      return true
    }

    const saveStart = Date.now()
    await invokeOuterMethod('save-em', [state])
    
    let numRules = state.rules.reduce((previousValue, currentRow) => previousValue + currentRow.length, 0)
    window.amplitude.getInstance().logEvent('em_save_examplemap_server', { numRules, saveTime: Date.now() - saveStart })
    this.lastKnownExampleMap = JSON.stringify(state)
    return false
  }

  async fetchSummary () {
    return invokeOuterMethod('fetch-summary')
  }

  async fetchIssueKey () {
    return invokeOuterMethod('fetch-issue-key')
  }

  async getCustomerIdentifier () {
    return invokeOuterMethod('get-customer-identifier')
  }

  async getHost () {
    return hosts.JIRA_SERVER
  }

  async loadInitialExampleMap () {
    return initialExampleMap
  }

  async openEditor (closeCallback) {
    await invokeOuterMethod('open-editor')
    closeCallback()
  }

  async closeEditor () {
    await invokeOuterMethod('close-editor')
  }
}
